export default [
  {
    name: '俄罗斯',
    callingCode: 7,
    code: 'RU',
    flag: require('./images/ru.svg'),
  },
  {
    name: '英国',
    callingCode: 44,
    code: 'GB',
    flag: require('./images/gb.svg'),
  },
  {
    name: '丹麦',
    callingCode: 45,
    code: 'DK',
    flag: require('./images/dk.svg'),
  },
  {
    name: '瑞典',
    callingCode: 46,
    code: 'SE',
    flag: require('./images/se.svg'),
  },
  {
    name: '中国',
    callingCode: 86,
    code: 'CN',
    flag: require('./images/cn.svg'),
  },
];
